<template>
   <v-app id="inspire">
    <v-card-title>
      Audio Collections
      <v-spacer></v-spacer>
        <v-dialog width="unset" height="unset" v-model="dialogs.upload">
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="uploading = false; updatingAudioCollection = false; " class="ml-5" color="secondary" v-bind="attrs" v-on="on">New</v-btn>
        </template>
        <v-card class="pa-2" background="white" width="400">
          <v-card-title> Upload audio collection </v-card-title>
            <v-textarea v-model="audioCollectionJson" label="New audio collection" clearable no-resize rows="17"> </v-textarea>
          <v-card-actions>
            <v-btn
              @click="uploadAudioCollection()"
              right
              :loading="uploading"
              :disabled="uploading || !validFileSpecified"
              color="primary"
            >
              Upload
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <div style="margin: 10px; text-color: white;" v-if="!this.jsonStructureValid" class="error"> JSON structure is not valid </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getAudioCollections"
      :expanded.sync="expanded"
      :hide-default-footer="true"
      disable-pagination
      show-expand
      single-expand
      item-key="id"
    > 
      <template v-slot:item.released="{ item }">
            <v-icon v-if="item.jsonData.audioCollection.released== 'RELEASED'">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
    </template>
       <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length">
          <v-card-actions>
            <v-btn
              @click="
                increaseVersion = 'RELEASE';
                generateRelease();
              "
              color="secondary"
              >Generate Release</v-btn
            >
          </v-card-actions>

          <v-data-table :headers="subHeaders" :items="audioCollectionReleases" item-key="id">
            <!-- ACTIONS -->
            <template v-slot:item.actions="{ item }">
              <!-- DELETE BUTTON -->
              <v-btn icon @click="deleteRelease(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </td>
      </template>
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <!-- DELETE -->
        <v-btn icon @click="openEditDialog(item)" color="secondary"
        ><v-icon>mdi-pencil</v-icon></v-btn> 
        <v-btn icon @click="deleteAudioCollections(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
  import {
    GET_AUDIO_COLLECTION_QUERY,
    ADD_OR_UPDATE_AUDIO_COLLECTIONS_JSON,
    DELETE_AUDIO_COLLECTION,
    GENERATE_AUDIO_COLLECTION_RELEASE,
    GET_AUDIO_COLLECTION_RELEASE_FILTER_QUERY,
    DELETE_AUDIO_COLLECTION_RELEASE
  } from '../../graphql/shootingProgramQueries.js';

  export default {
    components: {
      CConfirmationDialog: () => import('../common/CConfirmationDialog'),
    },
    name: 'AudioCollections',
    data: () => ({
      audioCollectionJson: '',
      currentAudioId: null,
      uploading: false,
      updatingAudioCollection: false,
      search: '',
      jsonStructureValid: true,
      expanded: [],
      increaseVersion: '',
      dialogs: {
          upload: false,
      },
      audioCollectionReleases: [],
       headers: [
          { text: 'Name', value: 'jsonData.audioCollection.name'},
          { text: 'Version', value: 'jsonData.version'},
          { text: 'Released', value: 'released', sortable: false},
          {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
        },
        ],
        subHeaders: [
          { text: 'Ver. Major', value: 'versionMajor', sortable: true },
          { text: 'Ver. Minor', value: 'versionMinor', sortable: true },
          { text: 'Ver. Patch', value: 'versionPatch', sortable: true },
          { text: 'ID', value: 'id', align: 'left', sortable: false },
          { text: 'Date', value: 'dateTime', sortable: true },
          {
            text: '',
            value: 'actions',
            sortable: false,
            align: 'right',
            width: '10%',
          },
        ],
    }),
    apollo: {
      $client: 'shootingProgramClient',
      getAudioCollections: {
        query: GET_AUDIO_COLLECTION_QUERY,
        loadingKey: 'loading',
        options: { fetchPolicy: 'cache-and-network' },
      },
    },
    watch: {
      expanded(expanded) {
        if(expanded.length > 0)
          this.fetchReleases(expanded[0].id);
      }
    },

    computed: {
      validFileSpecified() {
        return this.audioCollectionJson !== undefined && this.audioCollectionJson.length > 0;
      },
    },
    methods: {
      openEditDialog(collection){
        this.dialogs.upload = true;
        this.updatingAudioCollection = true;
        this.currentAudioId = collection.id;
        this.uploading = false; 
      },
      async fetchReleases(id){
          const result = await this.$apollo.query({ 
            query: GET_AUDIO_COLLECTION_RELEASE_FILTER_QUERY,
            variables: {
                id: id, 
                limit: 10
            },
            fetchPolicy: 'network-only',
          })
          this.audioCollectionReleases = result.data?.getAudioCollectionReleaseByFilter;
      },
      refetchAudioCollections() {
        this.$apollo.queries.getAudioCollections.refetch();
      },
      async deleteAudioCollections(id){
        if (
          await this.$refs.confirmationDialog.open(
            'Are you sure you want to delete this audio collection?'
          )
        ) {
          try {
              await this.$apollo.mutate({
                  mutation: DELETE_AUDIO_COLLECTION,
                  variables: {
                    id: id,
                  },
              });
          } catch (err) {
            alert('Error deleting audio collection! ' + err.message);
          }
          this.refetchAudioCollections();
        }
      },
        async uploadAudioCollection(){
          try{
            JSON.parse(this.audioCollectionJson); 
            this.jsonStructureValid = true;
          }catch(ex){
           this.jsonStructureValid = false;
           return;
          }

          if (this.validFileSpecified && this.jsonStructureValid) {
          try {
            // Set uploading state to indicate that the upload process is ongoing
            this.uploading = true;
            let id = null;

            if(this.updatingAudioCollection){
              id = this.currentAudioId;
            }

            await this.$apollo.mutate({
              mutation: ADD_OR_UPDATE_AUDIO_COLLECTIONS_JSON,
              variables: {
                id: id,
                audioCollectionJson: this.audioCollectionJson
              },
            });

            this.updatingAudioCollection = false;
            this.dialogs.upload = false;
            this.refetchAudioCollections();
          } catch (error) {
            console.error(error);
            this.uploading = false;
          }
          
 
        }
        },
        async generateRelease(){
          try {
            const collectionId = this.expanded[0].id;
            await this.$apollo.mutate({
              mutation: GENERATE_AUDIO_COLLECTION_RELEASE,
              variables: {
                audioCollectionId: collectionId,
                increaseVersion: this.increaseVersion,
              },
            }).then(() => this.fetchReleases(collectionId));
            this.increaseVersion = '';
            this.refetchAudioCollections();
            
          } catch (error) {
            alert('The service was not able to generate audio collection release.');
            this.increaseVersion = '';
          }
        },
        async deleteRelease(id){
          if (
              await this.$refs.confirmationDialog.open(
                'Are you sure you want to delete this audio collection release?'
              )
            ) {
              try {
                  await this.$apollo.mutate({
                      mutation: DELETE_AUDIO_COLLECTION_RELEASE,
                      variables: {
                        id: id,
                      },
                  });
              } catch (err) {
                alert('Error deleting audio collection! ' + err.message);
              }
              this.fetchReleases(this.expanded[0].id);
          }
        }
    },
  };
</script>


<style scoped>
</style>
